import { render } from "./Confidentiality.component.vue?vue&type=template&id=0456294e"
import script from "./Confidentiality.component.vue?vue&type=script&lang=js"
export * from "./Confidentiality.component.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__